import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Rootfile',
    entityNamePlural: 'Rootfiles',
    entityNameModule: 'cms/settings',
    filters: { active: true },
  }), [])
}
